import { defineStore } from 'pinia';

const initialStateAppearance = {
  bannersHome: [],
  bannersHomeMobile: [],
  bannersCasino: [],
  bannersPopup: [],
  logo: '',
  icon_img: '',
  links: [],
};

export const useAppearanceStore = defineStore('appearance', {
  state: (): AppearanceStoreState => ({
    isStoreBuilded: false,
    loading: false,
    appearance: { ...initialStateAppearance },
  }),
  getters: {
    bannersHomeFiltered(state) {
      return filterBanners(state.appearance.bannersHome);
    },
    bannersHomeMobileFiltered(state) {
      return filterBanners(state.appearance.bannersHomeMobile);
    },
    bannersCasinoFiltered(state) {
      const filtered = state.appearance.bannersCasino
        ? (filterByLanguageAndCountry(
            state.appearance.bannersCasino,
          ) as AppearanceBanner[])
        : [];

      return filterByDateRange(filtered);
    },
    linksFiltered(state) {
      return state.appearance.links
        ? (filterByLanguageAndCountry(
            state.appearance.links,
          ) as AppearanceLinks[])
        : [];
    },
    bannersPopupFiltered(state) {
      const filtered = state.appearance.bannersPopup
        ? (filterByLanguageAndCountry(
            state.appearance.bannersPopup,
          ) as AppearanceBanner[])
        : [];

      return filterByDateRange(filtered);
    },
    bannersRecommendDesktop(state) {
      const filtered = state.appearance.recommend_desktop
        ? (filterByLanguageAndCountry(
            state.appearance.recommend_desktop,
          ) as AppearanceBanner[])
        : [];

      return filterByDateRange(filtered);
    },
    bannersRecommendMobile(state) {
      const filtered = state.appearance.recommend_mobile
        ? (filterByLanguageAndCountry(
            state.appearance.recommend_mobile,
          ) as AppearanceBanner[])
        : [];

      return filterByDateRange(filtered);
    },
  },
  actions: {
    async getData() {
      this.loading = true;

      try {
        const { ApiService } = useApiService();

        await ApiService.get<API.AppearanceResponseBody>('/appearance')
          .then(({ data }: any) => {
            this.appearance = {
              ...data,
              bannersHome: normalizeObjectArray(data.banners),
              bannersHomeMobile: normalizeObjectArray(data.banners_home_mobile),
              bannersCasino: normalizeObjectArray(data.banners_casino),
              bannersPopup: normalizeObjectArray(data.banners_popup),
              recommend_desktop: normalizeObjectArray(data.recommend_desktop),
              recommend_mobile: normalizeObjectArray(data.recommend_mobile),
              logo: data.logo || '',
              icon_img: data.icon_img || '',
              links: normalizeObjectArray(data.links),
            };
          })
          .catch(() => {
            // TODO: Create defineErrorStore
            // defineErrorStore(err);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (err) {
        // TODO: Create defineErrorStore
        // defineErrorStore(err);
        this.loading = false;
      }
    },
  },
});

function filterBanners(array: AppearanceBanner[]) {
  if (!array || !Array.isArray(array)) {
    return [];
  }

  const filtered = filterByLanguageAndCountry(array) as AppearanceBanner[];

  return filterByDateRange(filtered);
}

function normalizeObjectArray(input: unknown) {
  if (input && typeof input === 'object') {
    return Array.isArray(input) ? input : Object.values(input);
  }

  return [];
}

function filterByLanguageAndCountry(
  array: AppearanceBanner[] | AppearanceLinks[],
) {
  const userLanguage = currentLocale();
  const { visitorOrUserCountry } = useParameters();

  if (!array || !Array.isArray(array)) {
    console.error('Array is not valid');

    return [];
  }

  return array.filter((item) => {
    const {
      all_languages: allLanguages,
      all_countries: allCountries,
      countries,
    } = item;

    // Verificando se a propriedade `language` ou `languages` está presente dependendo do tipo de item
    let languageOrLanguages: string = '';

    if ('language' in item) {
      languageOrLanguages = item.language ?? '';
    } else if ('languages' in item) {
      languageOrLanguages = item.languages ?? '';
    }

    const availableLanguages = normalizeStringJsonArray(
      languageOrLanguages || '',
    ).map((value: string) => value.toLowerCase());

    const availableCountries = normalizeStringJsonArray(countries).map(
      (value: string) => value.toLowerCase(),
    );

    const hasCountry =
      availableCountries &&
      availableCountries.includes(visitorOrUserCountry.value.toLowerCase());

    const hasLanguage =
      availableLanguages &&
      (availableLanguages.includes(userLanguage.toLowerCase()) ||
        availableLanguages.includes(userLanguage.split('-')[0]!.toLowerCase()));

    // todo: remove after migrate recommends to banners
    const fixToOldRecommended =
      item.section === 'recommend' &&
      (countries === null || countries === undefined);

    return (
      (allLanguages && allCountries) ||
      (allLanguages && hasCountry) ||
      (allCountries && hasLanguage) ||
      (hasCountry && hasLanguage) ||
      fixToOldRecommended
    );
  });
}

function filterByDateRange(array: AppearanceBanner[]): AppearanceBanner[] {
  const today = new Date();

  // today.setHours(0, 0, 0, 0);

  return array.filter((item: AppearanceBanner) => {
    const { schedule, expire_at } = item;

    if (!schedule && !expire_at) {
      return true;
    }

    const start = schedule ? new Date(schedule) : null;
    const end = expire_at ? new Date(expire_at) : null;

    // if (start) start.setHours(0, 0, 0, 0);
    // if (end) end.setHours(23, 59, 59, 999);

    const isAfterStart = !start || today >= start;
    const isBeforeEnd = !end || today <= end;

    return isAfterStart && isBeforeEnd;
  });
}
